import { Box, Tooltip } from "@mui/material";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { environmentBadge } from "../../utils/environment";


export default function EnvironmentBanner() {
    if (!environmentBadge) {
        return null;
    }

    const { label, shortLabel, background, color } = environmentBadge;

    return (
        <>
            <Box
                aria-hidden
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "5px",
                    background,
                }}
            />
            <Tooltip title={`${label} — os dados exibidos aqui não são reais.`}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        background,
                        color,
                        borderRadius: "4px",
                        padding: "4px 12px",
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontSize: "12px",
                        fontWeight: 700,
                        letterSpacing: "0.6px",
                        textTransform: "uppercase",
                        whiteSpace: "nowrap",
                    }}
                >
                    <WarningAmberIcon sx={{ fontSize: 16 }} />
                    {shortLabel}
                </Box>
            </Tooltip>
        </>
    );
}
